import { ReactComponent as ZoomIn } from '../assets/icons-2.0/Acercar.svg';
import { ReactComponent as Refresh } from '../assets/icons-2.0/Actualizar.svg';
import { ReactComponent as FolderAdd } from '../assets/icons-2.0/Agregar archivo.svg';
import { ReactComponent as UserAdd } from '../assets/icons-2.0/Agregar persona usuaria.svg';
import { ReactComponent as Adjustments } from '../assets/icons-2.0/Ajustes.svg';
import { ReactComponent as ZoomOut } from '../assets/icons-2.0/Alejar.svg';
import { ReactComponent as FolderOpen } from '../assets/icons-2.0/Archivo abierto.svg';
import { ReactComponent as FolderError } from '../assets/icons-2.0/Archivo incorrecto.svg';
import { ReactComponent as FolderFull } from '../assets/icons-2.0/Archivo lleno.svg';
import { ReactComponent as Archive } from '../assets/icons-2.0/Archivo.svg';
import { ReactComponent as Box } from '../assets/icons-2.0/Caja.svg';
import { ReactComponent as Calculator } from '../assets/icons-2.0/Calculadora.svg';
import { ReactComponent as Calendar } from '../assets/icons-2.0/Calendario.svg';
import { ReactComponent as Truck } from '../assets/icons-2.0/Camion.svg';
import { ReactComponent as Bell } from '../assets/icons-2.0/Campana.svg';
import { ReactComponent as Upload } from '../assets/icons-2.0/Carga.svg';
import { ReactComponent as Uploading } from '../assets/icons-2.0/Cargando.svg';
import { ReactComponent as Check } from '../assets/icons-2.0/Check.svg';
import { ReactComponent as ChevronDown } from '../assets/icons-2.0/Chevron abajo.svg';
import { ReactComponent as ChevronUp } from '../assets/icons-2.0/Chevron arriba.svg';
import { ReactComponent as ChevronRight } from '../assets/icons-2.0/Chevron derecha.svg';
import { ReactComponent as ChevronLeft } from '../assets/icons-2.0/Chevron izquierda.svg';
import { ReactComponent as CheckCircle } from '../assets/icons-2.0/Circulo con check.svg';
import { ReactComponent as CrossCircle } from '../assets/icons-2.0/Circulo con cruz.svg';
import { ReactComponent as ExclamationCircle } from '../assets/icons-2.0/Circulo con exclamacion.svg';
import { ReactComponent as QuestionMarkCircle } from '../assets/icons-2.0/Circulo con interrogacion.svg';
import { ReactComponent as ClockPlus } from '../assets/icons-2.0/Circulo con mas.svg';
import { ReactComponent as ClockLess } from '../assets/icons-2.0/Circulo con menos.svg';
import { ReactComponent as Circle } from '../assets/icons-2.0/Circulo vacio.svg';
import { ReactComponent as Share } from '../assets/icons-2.0/Compartir.svg';
import { ReactComponent as Receipt } from '../assets/icons-2.0/Comprobante.svg';
import { ReactComponent as Mail } from '../assets/icons-2.0/Correo.svg';
import { ReactComponent as Cross } from '../assets/icons-2.0/Cruz.svg';
import { ReactComponent as Download } from '../assets/icons-2.0/Descarga.svg';
import { ReactComponent as Library } from '../assets/icons-2.0/Edificio.svg';
import { ReactComponent as Scan } from '../assets/icons-2.0/Escaner.svg';
import { ReactComponent as ArrowRight } from '../assets/icons-2.0/Flecha a la derecha.svg';
import { ReactComponent as ArrowDown } from '../assets/icons-2.0/Flecha abajo.svg';
import { ReactComponent as ArrowUp } from '../assets/icons-2.0/Flecha arriba.svg';
import { ReactComponent as ArrowLeft } from '../assets/icons-2.0/Flecha izquierda.svg';
import { ReactComponent as Chart } from '../assets/icons-2.0/Gráfico.svg';
import { ReactComponent as Historial } from '../assets/icons-2.0/Historial.svg';
import { ReactComponent as Printer } from '../assets/icons-2.0/Impresora.svg';
import { ReactComponent as InformationCircle } from '../assets/icons-2.0/Info.svg';
import { ReactComponent as EditAlt } from '../assets/icons-2.0/Lapiz para editar.svg';
import { ReactComponent as Pencil } from '../assets/icons-2.0/Lapiz.svg';
import { ReactComponent as BookOpen } from '../assets/icons-2.0/Libro.svg';
import { ReactComponent as List } from '../assets/icons-2.0/Lista.svg';
import { ReactComponent as Key } from '../assets/icons-2.0/Llave.svg';
import { ReactComponent as Logout } from '../assets/icons-2.0/Login.svg';
import { ReactComponent as Lupa } from '../assets/icons-2.0/Lupa.svg';
import { ReactComponent as Light } from '../assets/icons-2.0/Luz.svg';
import { ReactComponent as Map } from '../assets/icons-2.0/Mapa.svg';
import { ReactComponent as Menu } from '../assets/icons-2.0/Menú.svg';
import { ReactComponent as Coin } from '../assets/icons-2.0/Moneda.svg';
import { ReactComponent as Eye } from '../assets/icons-2.0/Mostrar.svg';
import { ReactComponent as Globe } from '../assets/icons-2.0/Mundo.svg';
import { ReactComponent as EyeOff } from '../assets/icons-2.0/Ocultar.svg';
import { ReactComponent as Process } from '../assets/icons-2.0/Operar.svg';
import { ReactComponent as UserCircle } from '../assets/icons-2.0/Perfil.svg';
import { ReactComponent as User } from '../assets/icons-2.0/Persona usuaria.svg';
import { ReactComponent as Users } from '../assets/icons-2.0/Personas usuarias.svg';
import { ReactComponent as Collection } from '../assets/icons-2.0/Procesos masivos.svg';
import { ReactComponent as QRCode } from '../assets/icons-2.0/QR.svg';
import { ReactComponent as Clock } from '../assets/icons-2.0/Reloj.svg';
import { ReactComponent as Add } from '../assets/icons-2.0/Signo más.svg';
import { ReactComponent as SwitchHorizontal } from '../assets/icons-2.0/Switch horizontal.svg';
import { ReactComponent as SwitchVertical } from '../assets/icons-2.0/Switch vertical.svg';
import { ReactComponent as Trash } from '../assets/icons-2.0/Tacho.svg';
import { ReactComponent as Template } from '../assets/icons-2.0/Template.svg';
import { ReactComponent as Cog } from '../assets/icons-2.0/Tuerca.svg';
import { ReactComponent as LocationMarker } from '../assets/icons-2.0/Ubicación.svg';
import { ReactComponent as Exclamation } from '../assets/icons-2.0/Warning.svg';
import { ReactComponent as Whatsapp } from '../assets/icons-2.0/WhatsApp.svg';
import { ReactComponent as Document } from '../assets/icons-2.0/Documentos.svg';
import { ReactComponent as Identification } from '../assets/icons-2.0/Identificacion.svg';
import { ReactComponent as Server } from '../assets/icons-2.0/Servidor.svg';
import { ReactComponent as Image } from '../assets/icons-2.0/Imagen.svg';
import { ReactComponent as Camera } from '../assets/icons-2.0/Camara.svg';
import { ReactComponent as Off } from '../assets/icons-2.0/Apagado.svg';
import { ReactComponent as Bank } from '../assets/icons-2.0/Banco.svg';
import { ReactComponent as ReadyPackage } from '../assets/icons-2.0/Paquete listo.svg';
import { ReactComponent as Expand } from '../assets/icons-2.0/Expandir.svg';
import { ReactComponent as Detail } from '../assets/icons-2.0/Detalle.svg';
import { ReactComponent as Diamond } from '../assets/icons-2.0/Diamante.svg';
import { ReactComponent as Motorbike } from '../assets/icons-2.0/Motocicleta.svg';
import { ReactComponent as Package } from '../assets/icons-2.0/Paquete.svg';
import { ReactComponent as Promotion } from '../assets/icons-2.0/Promocion.svg';

export const icons = {
  add: { name: 'Agregar', component: Add },
  adjustments: { name: 'Ajustes', component: Adjustments },
  archive: { name: 'Archivo', component: Archive },
  'arrow-down': { name: 'Flecha abajo', component: ArrowDown },
  'arrow-left': { name: 'Flecha izquierda', component: ArrowLeft },
  'arrow-right': { name: 'Flecha derecha', component: ArrowRight },
  'arrow-up': { name: 'Flecha arriba', component: ArrowUp },
  bell: { name: 'Campana', component: Bell },
  'book-open': { name: 'Libro', component: BookOpen },
  box: { name: 'Caja', component: Box },
  calculator: { name: 'Calculadora', component: Calculator },
  calendar: { name: 'Calendario', component: Calendar },
  'chart-square-bar': { name: 'Gráfico', component: Chart },
  check: { name: 'Check', component: Check },
  'check-circle': { name: 'Círculo con check', component: CheckCircle },
  'chevron-down': { name: 'Chevron abajo', component: ChevronDown },
  'chevron-left': { name: 'Chevron izquierda', component: ChevronLeft },
  'chevron-right': { name: 'Chevron derecha', component: ChevronRight },
  'chevron-up': { name: 'Chevron arriba', component: ChevronUp },
  circle: { name: 'Círculo vacío', component: Circle },
  'clipboard-list': { name: 'Lista', component: List },
  clock: { name: 'Reloj', component: Clock },
  cog: { name: 'Tuerca', component: Cog },
  collection: { name: 'Procesos masivos', component: Collection },
  'currency-dollar': { name: 'Moneda', component: Coin },
  'document-text': { name: 'Documentos', component: Document },
  download: { name: 'Descarga', component: Download },
  'edit-alt': { name: 'Lápiz para editar', component: EditAlt },
  'exclamation-circle': { name: 'Círculo con exclamación', component: ExclamationCircle },
  'eye-off': { name: 'Ocultar', component: EyeOff },
  'folder-add': { name: 'Agregar archivo', component: FolderAdd },
  'folder-error': { name: 'Archivo incorrecto', component: FolderError },
  'folder-full': { name: 'Archivo lleno', component: FolderFull },
  historial: { name: 'Historial', component: Historial },
  identification: { name: 'Identificación', component: Identification },
  'information-circle': { name: 'Info', component: InformationCircle },
  key: { name: 'Llave', component: Key },
  library: { name: 'Edificio', component: Library },
  'light-bulb': { name: 'Encendido', component: Light },
  logout: { name: 'Login', component: Logout },
  mail: { name: 'Correo', component: Mail },
  map: { name: 'Mapa', component: Map },
  menu: { name: 'Menú', component: Menu },
  motorbike: { name: 'Moto', component: Motorbike },
  'clock-less': { name: 'Círculo con menos', component: ClockLess },
  package: { name: 'Paquete', component: Package },
  process: { name: 'Operar', component: Process },
  'folder-open': { name: 'Archivo abierto', component: FolderOpen },
  pencil: { name: 'Lápiz', component: Pencil },
  'clock-plus': { name: 'Círculo con más', component: ClockPlus },
  printer: { name: 'Impresora', component: Printer },
  'user-circle': { name: 'Perfil', component: UserCircle },
  qrcode: { name: 'QR', component: QRCode },
  refresh: { name: 'Actualizar', component: Refresh },
  scan: { name: 'Escáner', component: Scan },
  share: { name: 'Compartir', component: Share },
  eye: { name: 'Mostrar', component: Eye },
  server: { name: 'Servidor', component: Server },
  spinner: { name: 'Cargando', component: Uploading },
  'switch-horizontal': { name: 'Switch horizontal', component: SwitchHorizontal },
  'switch-vertical': { name: 'Switch vertical', component: SwitchVertical },
  template: { name: 'Plantilla', component: Template },
  trash: { name: 'Tacho', component: Trash },
  truck: { name: 'Camión', component: Truck },
  'location-marker': { name: 'Ubicación', component: LocationMarker },
  upload: { name: 'Carga', component: Upload },
  user: { name: 'Persona usuaria', component: User },
  'user-add': { name: 'Agregar persona usuaria', component: UserAdd },
  users: { name: 'Personas usuarias', component: Users },
  exclamation: { name: 'Warning', component: Exclamation },
  whatsapp: { name: 'WhatsApp', component: Whatsapp },
  globe: { name: 'Mundo', component: Globe },
  'x-circle': { name: 'Círculo con cruz', component: CrossCircle },
  x: { name: 'Cruz', component: Cross },
  'zoom-in': { name: 'Acercar', component: ZoomIn },
  'zoom-out': { name: 'Alejar', component: ZoomOut },
  'question-mark-circle': { name: 'Círculo con interrogación', component: QuestionMarkCircle },
  search: { name: 'Lupa', component: Lupa },
  receipt: { name: 'Comprobante', component: Receipt },
  image: { name: 'Imagen', component: Image },
  camera: { name: 'Cámara', component: Camera },
  'light-off': { name: 'Apagado', component: Off },
  bank: { name: 'Banco', component: Bank },
  'ready-package': { name: 'Paquete listo', component: ReadyPackage },
  expand: { name: 'Expandir', component: Expand },
  detail: { name: 'Detalle', component: Detail },
  diamond: { name: 'Diamante', component: Diamond },
  promotion: { name: 'Promoción', component: Promotion },
};
